import { useMemo } from "react";
import { JsonParam, StringParam, useQueryParam } from "use-query-params";

import type { Conversation } from "../types";

export default function useActiveConversationState() {
  const [accountId, setAccountId] = useQueryParam("accountId", StringParam);
  const [conversationUrn, setConversationUrn] = useQueryParam(
    "urn",
    StringParam,
  );
  const [highlight, setHighlight] = useQueryParam("highlight", JsonParam);

  function setActiveConversationState(
    conversationUrn: string,
    accountId: string,
    highlight: Conversation["highlight"],
  ) {
    setConversationUrn(conversationUrn);
    setAccountId(accountId);
    setHighlight(highlight);
  }

  function resetActiveConversation() {
    setConversationUrn(undefined);
    setAccountId(undefined);
    setHighlight(undefined);
  }

  const activeConversationState = useMemo(
    () =>
      conversationUrn && accountId
        ? { conversationUrn, accountId, highlight }
        : undefined,
    [conversationUrn, accountId, highlight],
  );

  return {
    activeConversationState,
    setActiveConversationState,
    resetActiveConversation,
  };
}
